import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderSlot as _renderSlot, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "modal-dialog" }
const _hoisted_2 = { class: "modal-content" }
const _hoisted_3 = { class: "modal-header" }
const _hoisted_4 = { class: "modal-title" }
const _hoisted_5 = { class: "modal-body" }
const _hoisted_6 = { class: "modal-footer" }
const _hoisted_7 = ["onClick"]

import { ref } from 'vue';
import Button from './Button.vue';


interface ButtonOption {
    color: string,
    text: string,
    onClick: () => void,
}


export default /*#__PURE__*/_defineComponent({
  __name: 'Modal',
  props: {
    title: {},
    bodyText: {},
    show: { type: Boolean },
    showButtonText: {},
    hideClose: { type: Boolean },
    onClose: { type: Function },
    onConfirm: { type: Function },
    confirmText: {},
    customButtons: {}
  },
  emits: ['update:show'],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const internalShow = ref(false);
const emit = __emit

const doConfirm = () => {
    if (props.onConfirm && props.onConfirm()) {
        doClose();
    }
}

const doClose = () => {
    if (props.onClose && props.onClose()) {
        emit("update:show", false);
        internalShow.value = false;
    }
    else {
        emit("update:show", false);
        internalShow.value = false;
    }
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.showButtonText)
      ? (_openBlock(), _createBlock(Button, {
          key: 0,
          text: _ctx.showButtonText,
          "on-click": () => internalShow.value = !internalShow.value
        }, null, 8, ["text", "on-click"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: _normalizeClass('modal ' + ((_ctx.show || internalShow.value) ? 'd-block show' : '')),
      tabindex: "-1"
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("h5", _hoisted_4, _toDisplayString(props.title), 1),
            _createElementVNode("button", {
              type: "button",
              class: "btn-close",
              "data-bs-dismiss": "modal",
              onClick: doClose,
              "aria-label": "Close"
            })
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("p", null, _toDisplayString(_ctx.bodyText), 1),
            _renderSlot(_ctx.$slots, "default")
          ]),
          _createElementVNode("div", _hoisted_6, [
            (!_ctx.hideClose)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  onClick: doClose,
                  type: "button",
                  class: "btn btn-secondary",
                  "data-bs-dismiss": "modal"
                }, "Close"))
              : _createCommentVNode("", true),
            (_ctx.onConfirm)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 1,
                  onClick: doConfirm,
                  type: "button",
                  class: "btn btn-primary"
                }, _toDisplayString(_ctx.confirmText ||
                        "Confirm"), 1))
              : _createCommentVNode("", true),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.customButtons, (button) => {
              return (_openBlock(), _createElementBlock("button", {
                key: button.text,
                onClick: button.onClick,
                type: "button",
                class: _normalizeClass('btn btn-' + button.color)
              }, _toDisplayString(button.text), 11, _hoisted_7))
            }), 128))
          ])
        ])
      ])
    ], 2)
  ], 64))
}
}

})